import type { CodexNotification } from './index.ts';

/** Server-owned, exact-turn progress; does not change native turn state. */
export interface InputPreparationState {
  threadId: string;
  turnId: string;
  kind: 'pdf';
  revision: number;
  sequence: number;
  status: 'preparing' | 'completed' | 'failed';
  completed: number;
  total: number;
}

export function isInputPreparationEvent(value: unknown): value is CodexNotification & { params: InputPreparationState } {
  if (!value || typeof value !== 'object') return false;
  const event = value as Record<string, unknown>, p = event.params as Record<string, unknown> | undefined;
  const identity = (id: unknown) => typeof id === 'string' && id.length > 0 && id.length <= 200 && !/[\s\u0000-\u001f]/.test(id);
  return event.method === 'reados/inputPreparation' && !!p && typeof p === 'object' && !Array.isArray(p)
    && identity(p.threadId) && identity(p.turnId) && p.kind === 'pdf'
    && Number.isSafeInteger(p.revision) && Number(p.revision) >= 1
    && Number.isSafeInteger(p.sequence) && Number(p.sequence) >= 0
    && ['preparing', 'completed', 'failed'].includes(String(p.status))
    && Number.isSafeInteger(p.completed) && Number(p.completed) >= 0
    && Number.isSafeInteger(p.total) && Number(p.total) > 0 && Number(p.completed) <= Number(p.total);
}
